import { render, staticRenderFns } from "./Courrier.vue?vue&type=template&id=f4f115f4&"
import script from "./Courrier.vue?vue&type=script&lang=js&"
export * from "./Courrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports